import type { localeNames } from "./externalTypes";

const localeTranslationsConst = [
  "ACCOUNT_SEARCH_FORM_HEADING",
  "ACCOUNT_SEARCH_INPUT_LABEL",
  "ACCOUNT_SEARCH_SUBMIT_BTN_TEXT",
  "WELCOME_HEADING",
  "MORE_ACCOUNT",
  "MORE_ACCOUNTS",
  "RECENTLY_ACCESSED",
  `ACCOUNTS`,
  `ACCOUNT_SWITCHER_HEADER`,
  `ACCOUNT_ONLY_SWITCHER_HEADER`,
  `BACK`,
  `CLOSE`,
  `core.500_ERROR`,
  `core.ERROR_HEADING`,
  `LOADING_ACCOUNT_INFORMATION`,
  `PLEASE_REFRESH`,
  `SWITCH_ACCOUNT`,
  `USERS`,
  `VIEWABLE_ACCOUNTS`,
  `VIEWABLE_USERS`,
  `SEARCH`,
  "NO_ACCOUNTS_FOUND"
] as const;

export const localeNamesConst = ["en-US", "es-US", "en-CA", "fr-CA"] as const;

const LocaleTranslationsObj = localeTranslationsConst.reduce(
  (acc, next) => ({ ...acc, [next]: null }),
  {} as Record<string, null>
);

const LocaleNamesObj = localeNamesConst.reduce(
  (acc, next) => ({ ...acc, [next]: null }),
  {} as Record<string, null>
);

export type LocaleNamesMap = Record<localeNames, localeTranslationsMap>;

export type localeTranslationsMap = Partial<Record<localeTranslations, string>>;

export interface LocaleContextState {
  locale: localeNames;
  setLocale: (locale: localeNames) => void;
  getLocaleString: (name: localeTranslations) => string;
}

export type localeTranslations = (typeof localeTranslationsConst)[number];

export function isLocaleTranslation(
  value: string
): value is localeTranslations {
  return value in LocaleTranslationsObj;
}
export function isLocaleName(value: string): value is localeNames {
  return value in LocaleNamesObj;
}

// en-US = Locale Name
// ACCOUNT_SEARCH_FORM_HEADING = Locale Translation
// Please enter a valid Account Id = Locale Value
